import repository from './repository'

const resource = 'voucher-details'

export default {
  index (params) {
    return repository.get(resource, { params })
  },
  store (data) {
    return repository.post(resource, data)
  },
  update (id, data) {
    return repository.put(`${resource}/${id}`, data)
  },
  verify (data) {
    return repository.post(`${resource}/verify`, data)
  },
}
